import React from "react";

const Boost = () => {
  return (
    <div className="bg-[#35323E] py-10 text-center">
      <div className="w-full p-2 sm:p-0 sm:w-[85%] mx-auto ">
        <h2 className="text-3xl text-white">Boost Your Links Today</h2>
        <div className="mt-3">
          <button className="bg-indigo-600 px-5 py-2 rounded-full text-white">
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default Boost;
